import createToggleComponent from './toggle';
export default createToggleComponent('radio');
